module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new/_next/static/images/fullwidth_mobile-eacda8610c9d47eab4702af83463ae84.jpg";